import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {AuthenticationService} from "@alfresco/adf-core";
import {Observable} from "rxjs";
import { algAuthorizationHeader } from '../alg-auth';

@Injectable({
  providedIn: 'root'
})
export class ProcessDefinitionService {

  constructor(private http: HttpClient, private authService: AuthenticationService) { }

  getProcessDefinitions() {
    const endpointUrl = window.location.origin + '/alfresco/api/-default-/public/workflow/versions/1/process-definitions/';
    let headers = new HttpHeaders();
    let auth = algAuthorizationHeader(this.authService)
    headers = headers.append('Authorization', auth);
    const params = {headers: headers};
    return this.http.get(endpointUrl, params);
  }

  getProcessDefinitionForm(processDefinitionId: string) {
    const endpointUrl = `${window.location.origin}/alfresco/api/-default-/public/workflow/versions/1/process-definitions/${processDefinitionId}/start-form-model`;
    let headers = new HttpHeaders();
    // Cet appel n'utilisait que la branche Basic : il envoyait un ticket Basic meme en mode
    // OAuth, ou il aurait echoue. Le helper couvre les deux modes.
    headers = headers.append('Authorization', algAuthorizationHeader(this.authService));
    const params = {headers: headers};
    return this.http.get(endpointUrl, params);
  }

  search(searchTerm: string) {
    let body = {
      "query": {
        "query": `SELECT * FROM cm:person WHERE cm:userName like '%${searchTerm}%' OR cm:firstName like '%${searchTerm}%' OR cm:lastName like '%${searchTerm}%' OR cm:email like '%${searchTerm}%'`,
        "language": "cmis"
      },
      "include": "properties"
    }
    const endpointUrl = window.location.origin + `/alfresco/api/-default-/public/search/versions/1/search`;
    let headers = new HttpHeaders();
    let auth = algAuthorizationHeader(this.authService)
    headers = headers.append('Authorization', auth);
    const params = {headers: headers};
    return this.http.post(endpointUrl, body, params);
  }

  getProcessDefinitionDiagram(id): Observable<Blob> {
    const endpointUrl = window.location.origin + `/alfresco/api/-default-/public/workflow/versions/1/process-definitions/${id}/image`;
    let headers = new HttpHeaders();
    let auth = algAuthorizationHeader(this.authService)
    headers = headers.append('Authorization', auth);

    return this.http.get(endpointUrl, {headers: headers, responseType: 'blob'});
  }

  getProcessDefinitionDiagramBis(id): Observable<Blob> {
    const endpointUrl = window.location.origin + `/alfresco/s/api/workflow-instances/activiti$${id}/diagram`;
    let headers = new HttpHeaders();
    let auth = algAuthorizationHeader(this.authService)
    headers = headers.append('Authorization', auth);

    return this.http.get(endpointUrl, {headers: headers, responseType: 'blob'});
  }
}
